var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.props.sortable)?_c('font-awesome-icon',{staticClass:"fa-pull-right",attrs:{"icon":_vm.icon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }